import React, { useRef } from 'react';
import {
    Container,
    StyledCallout,
    CircleIcon
} from './ListingToursAndFloorplans.styles';
import { Button, Text } from '@blueprint/ui';
import { FloorplanMedium, VideoCameraOutlineMedium } from '@blueprint/icons';
import { buildCombinedVirtualTours } from 'listing-details/helpers';
import { ListingToursAndFloorplansProps } from './ListingToursAndFloorplans.types';
import {
    trackOpenVirtualTours,
    trackOpenFloorPlans
} from './ListingToursAndFloorplans.tracking';

const ListingToursAndFloorplans = ({
    data,
    openModal
}: ListingToursAndFloorplansProps) => {
    const floorPlanModalTriggerOrigin = useRef(null);
    const virtualTourModalTriggerOrigin = useRef(null);

    const virtualToursClick = () => {
        trackOpenVirtualTours();
        openModal('tours', virtualTourModalTriggerOrigin);
    };

    const floorPlansClick = () => {
        trackOpenFloorPlans();
        openModal('floorplans', floorPlanModalTriggerOrigin);
    };

    const numFloorplans = data.content.floorPlan?.length || 0;

    const { tours, videos, links } = data?.embeddedContent;
    const numTours = buildCombinedVirtualTours(
        tours || [],
        videos || [],
        links || []
    ).length;

    const floorplansText = `floor plan${numFloorplans > 1 ? 's' : ''}`;
    const toursText = `virtual tour${numTours > 1 ? 's' : ''}`;

    return (
        <Container>
            {numFloorplans ? (
                <StyledCallout>
                    <CircleIcon>
                        <FloorplanMedium />
                    </CircleIcon>
                    <Text isBold size="7">
                        {`${numFloorplans} ${floorplansText} available`}
                    </Text>
                    <Text>
                        {`View the ${floorplansText} to understand the space and layout
                        of this property`}
                        .
                    </Text>
                    <Button
                        ref={floorPlanModalTriggerOrigin}
                        variant="secondary"
                        isFullWidth
                        onClick={floorPlansClick}
                        data-testid="floorplan-block-link"
                    >
                        {`View ${floorplansText}`}
                    </Button>
                </StyledCallout>
            ) : null}
            {numTours ? (
                <StyledCallout>
                    <CircleIcon>
                        <VideoCameraOutlineMedium />
                    </CircleIcon>
                    <Text isBold size="7">
                        {`${numTours} ${toursText} available`}
                    </Text>
                    <Text>
                        Step inside the property with a virtual tour or video
                        walkthrough.
                    </Text>
                    <Button
                        ref={virtualTourModalTriggerOrigin}
                        variant="secondary"
                        isFullWidth
                        onClick={virtualToursClick}
                        data-testid="video-gallery-block-link"
                    >
                        {`View ${toursText}`}
                    </Button>
                </StyledCallout>
            ) : null}
        </Container>
    );
};

export default ListingToursAndFloorplans;
